import { ActionType, NetworkActionPrefix } from '../utils/constants';
import {
    DecisionPollApi, DecisionPollReplyOptionTypeApi, DecisionPollRespondentApi,
    NotificationSendingTimeTypeApi, PerformanceIndicatorPollBatchApi, PerformanceIndicatorPollBatchUserApi,
    PerformanceIndicatorPollGeneralResponseApi, PerformanceIndicatorPollSettingsApi, PerformanceIndicatorPollStatusApi,
    PerformanceIndicatorPollValueAggregationTypeApi, PerformanceIndicatorPollValueTypeApi, PollReportApi, PollSettingsScaleApi
} from 'for-straction-service-api';
import { entityLifecycleActionSet, networkAPIAction } from '../utils/actionCreatorsFactory';

const
    pollReportApi = new PollReportApi(),
    pollSettingsApi = new PerformanceIndicatorPollSettingsApi(),
    pollSettingsScaleApi = new PollSettingsScaleApi(),
    pollBatchUserApi = new PerformanceIndicatorPollBatchUserApi(),
    pollGeneralResponseApi = new PerformanceIndicatorPollGeneralResponseApi(),

    decisionPollReplyOptionTypeActionSet = entityLifecycleActionSet('DecisionPollReplyOptionType', 'DECISION_POLL_REPLY_OPTION_TYPE', 'decisionPollReplyOptionType', DecisionPollReplyOptionTypeApi, {
        loadAll: true
    }, true),

    decisionPollActionSet = entityLifecycleActionSet('DecisionPoll', 'DECISION_POLL', 'decisionPoll', DecisionPollApi, {
        loadAll: true,
        add: true,
        delete: true
    }, true),

    polls = {
        addPollScaleValues(pollSettingID, scaleValues) {
            return (dispatch) => {
                dispatch({
                    type: ActionType.ADD_POLL_SCALE_VALUES,
                    pollSettingID,
                    scaleValues
                });

                dispatch(polls.syncNewPollScaleValues(pollSettingID, scaleValues));
            };
        },
        syncNewPollScaleValues(pollSettingID, scaleValues) {
            return networkAPIAction(pollSettingsScaleApi, 'pollSettingsScaleAddAllPut', NetworkActionPrefix.ADD_POLL_SCALE_VALUES_PREFIX, { pollSettingID, scaleValues }, scaleValues);
        },
        editPollScaleValues(pollSettingID, scaleValues) {
            return (dispatch) => {
                dispatch({
                    type: ActionType.EDIT_POLL_SCALE_VALUES,
                    pollSettingID,
                    scaleValues
                });

                dispatch(polls.syncPollScaleValues(pollSettingID, scaleValues));
            };
        },
        syncPollScaleValues(pollSettingID, scaleValues) {
            return networkAPIAction(pollSettingsScaleApi, 'pollSettingsScaleEditAllPut', NetworkActionPrefix.EDIT_POLL_SCALE_VALUES_PREFIX, { pollSettingID, scaleValues }, scaleValues);
        },
        deletePollScaleValues(pollSettingID, scaleIDs) {
            return (dispatch) => {
                dispatch({
                    type: ActionType.DELETE_POLL_SCALE_VALUES,
                    pollSettingID,
                    scaleIDs
                });

                dispatch(polls.syncDeletedPollScaleValues(pollSettingID, scaleIDs));
            };
        },
        syncDeletedPollScaleValues(pollSettingID, scaleIDs) {
            return networkAPIAction(pollSettingsScaleApi, 'pollSettingsScaleDeleteAllPut', NetworkActionPrefix.DELETE_POLL_SCALE_VALUES_PREFIX, { pollSettingID, scaleIDs }, scaleIDs);
        },
        addPollResponses(responses) {
            return dispatch => new Promise((resolve, reject) => {
                dispatch({
                    type: ActionType.ADD_POLL_RESPONSES,
                    responses
                });

                dispatch(polls.syncPollResponses(responses))
                    .then(resolve, reject);
            });
        },
        syncPollResponses(responses) {
            return networkAPIAction(pollReportApi, 'pollReportAddResponsesPut', NetworkActionPrefix.ADD_POLL_RESPONSES_PREFIX, { responses }, responses);
        },
        addPollSettings(settings) {
            return dispatch => new Promise((resolve, reject) => {
                dispatch({
                    type: ActionType.ADD_POLL_SETTINGS,
                    pollSettingsID: settings.ID,
                    settings
                });

                dispatch(polls.syncNewPollSettings(settings))
                    .then(resolve, reject);
            });
        },
        syncNewPollSettings(settings) {
            return networkAPIAction(pollSettingsApi, 'performanceIndicatorPollSettingsAddPut', NetworkActionPrefix.ADD_POLL_SETTINGS_PREFIX, { pollSettingsID: settings.ID, settings }, settings);
        },
        editPollSettings(primaryKey, settings) {
            return (dispatch) => {
                dispatch({
                    type: ActionType.EDIT_POLL_SETTINGS,
                    pollSettingsID: primaryKey,
                    settings
                });

                dispatch(polls.syncPollSettings(primaryKey, settings));
            };
        },
        syncPollSettings(primaryKey, settings) {
            return networkAPIAction(pollSettingsApi, 'performanceIndicatorPollSettingsEditPut', NetworkActionPrefix.EDIT_POLL_SETTINGS_PREFIX, { settings, pollSettingsID: primaryKey }, settings, primaryKey);
        },
        ignorePoll(pollBatchUserID) {
            return dispatch => new Promise((resolve, reject) => {
                dispatch({
                    type: ActionType.IGNORE_POLL_BATCH_USER,
                    pollBatchUserID
                });

                dispatch(polls.syncIgnoredPollSettings(pollBatchUserID))
                    .then(resolve, reject);
            });
        },
        syncIgnoredPollSettings(pollBatchUserID) {
            return networkAPIAction(pollBatchUserApi, 'performanceIndicatorPollBatchUserIgnorePollGet', NetworkActionPrefix.IGNORE_POLL_BATCH_USER_PREFIX, { pollBatchUserID }, pollBatchUserID);
        },
        deletePollSettings(primaryKey) {
            return (dispatch) => {
                dispatch({
                    type: ActionType.DELETE_POLL_SETTINGS,
                    pollSettingsID: primaryKey
                });

                return dispatch(polls.syncDeletedPollSettings(primaryKey));
            };
        },
        syncDeletedPollSettings(primaryKey) {
            return networkAPIAction(pollSettingsApi, 'performanceIndicatorPollSettingsDeleteGet', NetworkActionPrefix.DELETE_POLL_SETTINGS_PREFIX, { pollSettingsID: primaryKey }, primaryKey);
        },
        addMoodIndexPoll() {
            return dispatch => new Promise((resolve, reject) => {
                dispatch({
                    type: ActionType.ADD_MOOD_INDEX_POLL
                });

                dispatch(polls.syncAddMoodIndexPoll())
                    .then(resolve, reject);
            });
        },
        syncAddMoodIndexPoll() {
            return networkAPIAction(pollSettingsApi, 'performanceIndicatorPollSettingsAddMoodIndexPollGet', NetworkActionPrefix.ADD_MOOD_INDEX_POLL_PREFIX);
        },
        loadPollScaleValues(pollSettingID) {
            return networkAPIAction(pollSettingsScaleApi, 'pollSettingsScaleLoadAllWithPollIDGet', NetworkActionPrefix.LOAD_POLL_SCALE_VALUES_PREFIX, { pollSettingID }, pollSettingID);
        },
        loadPollSettings(settingID, { batchesMaxCount } = {}) {
            return networkAPIAction(pollSettingsApi, 'performanceIndicatorPollSettingsLoadSettingsByIDGet', NetworkActionPrefix.LOAD_POLL_SETTINGS_PREFIX, { settingID }, settingID, { batchesMaxCount });
        },
        loadPollSettingsList({ batchesMaxCount } = {}) {
            return networkAPIAction(pollSettingsApi, 'performanceIndicatorPollSettingsLoadAllLightReportGet', NetworkActionPrefix.LOAD_POLL_SETTINGS_LIST_PREFIX, { batchesMaxCount }, { batchesMaxCount });
        },
        loadLastAnsweredPollBatch(pollSettingID) {
            return networkAPIAction(PerformanceIndicatorPollBatchApi, 'performanceIndicatorPollBatchLoadLastAnsweredPollBatchGet', NetworkActionPrefix.LOAD_LAST_ANSWERED_POLL_BATCH_PREFIX, { pollSettingID }, pollSettingID);
        },
        loadPollValueAggregationTypes: networkAPIAction.bind(this, new PerformanceIndicatorPollValueAggregationTypeApi(), 'performanceIndicatorPollValueAggregationTypeLoadAllGet', NetworkActionPrefix.LOAD_POLL_VALUE_AGGREGATION_TYPES_PREFIX, {}),
        loadPollValueTypes: networkAPIAction.bind(this, new PerformanceIndicatorPollValueTypeApi(), 'performanceIndicatorPollValueTypeLoadAllGet', NetworkActionPrefix.LOAD_POLL_VALUE_TYPES_PREFIX, {}),
        loadPollStatuses: networkAPIAction.bind(this, new PerformanceIndicatorPollStatusApi(), 'performanceIndicatorPollStatusLoadAllGet', NetworkActionPrefix.LOAD_POLL_STATUSES_PREFIX, {}),
        loadUnrespondedPolls: networkAPIAction.bind(this, pollReportApi, 'pollReportLoadUnrespondedPollsGet', NetworkActionPrefix.LOAD_UNRESPONDED_POLLS_PREFIX, {}),
        loadPollAnswersForPeriod(pollSettingID, startDate, endDate) {
            return networkAPIAction(pollBatchUserApi, 'performanceIndicatorPollBatchUserLoadAllInTimePeriodGet', NetworkActionPrefix.LOAD_PERFORMANCE_INDICATOR_POLL_BATCH_USERS_FROM_TIME_PERIOD_PREFIX, { pollSettingID, startDate }, pollSettingID, startDate, endDate, {});
        },
        loadPollGeneralAnswersForPeriod(pollSettingID, startDate, endDate) {
            return networkAPIAction(pollGeneralResponseApi, 'performanceIndicatorPollGeneralResponseLoadAllInTimePeriodGet', NetworkActionPrefix.LOAD_PERFORMANCE_INDICATOR_POLL_GENERAL_RESPONSE_FROM_TIME_PERIOD_PREFIX, { pollSettingID, startDate }, pollSettingID, startDate, endDate, {});
        },
        sendRemindersForUnansweredPollUsersForPeriod(pollSettingID, startDate, endDate) {
            return networkAPIAction(pollBatchUserApi, 'performanceIndicatorPollBatchUserSendRemindersToUnansweredUsersFromPeriodGet', NetworkActionPrefix.SEND_REMINDERS_TO_UNANSWERED_POLL_USERS_PREFIX, {}, pollSettingID, startDate, endDate);
        },
        loadNotificationSendingTimeTypes: networkAPIAction.bind(this, new NotificationSendingTimeTypeApi(), 'notificationSendingTimeTypeLoadAllGet', NetworkActionPrefix.LOAD_NOTIFICATION_SENDING_TIME_TYPES_PREFIX, {}),
        clearCurrentPollPeriodAndSend(settingID) {
            return networkAPIAction(pollSettingsApi, 'performanceIndicatorPollSettingsClearCurrentPollPeriodAndSendGet', NetworkActionPrefix.CLEAR_CURRENT_POLL_PERIOD_AND_SEND_PREFIX, { settingID }, settingID);
        },
        loadAllDecisionPollReplyOptionTypes() {
            return decisionPollReplyOptionTypeActionSet.loadAllDecisionPollReplyOptionTypes();
        },
        loadAllDecisionPolls() {
            return decisionPollActionSet.loadAllDecisionPolls();
        },
        addDecisionPoll(decisionPoll, sync) {
            return decisionPollActionSet.addDecisionPoll(decisionPoll, sync);
        },
        deleteDecisionPoll(decisionPollID) {
            return decisionPollActionSet.removeDecisionPoll(decisionPollID);
        },
        addAllDecisionPollRespondents(decisionPollID, pollRespondents) {
            return dispatch => new Promise((resolve, reject) => {
                dispatch({
                    type: ActionType.ADD_ALL_DECISION_POLL_RESPONDENTS,
                    decisionPollID,
                    pollRespondents
                });

                dispatch(polls.syncNewDecisionPollRespondents(decisionPollID, pollRespondents))
                    .then(resolve, reject);
            });
        },
        syncNewDecisionPollRespondents(decisionPollID, pollRespondents) {
            return networkAPIAction(new DecisionPollRespondentApi(), 'decisionPollRespondentAddAllPut', NetworkActionPrefix.ADD_ALL_DECISION_POLL_RESPONDENTS_PREFIX, { decisionPollID, pollRespondents }, pollRespondents);
        },
        loadPollBatchSlice(pollSettingID, { startID, maxCount, order } = {}) {
            return networkAPIAction(
                PerformanceIndicatorPollBatchApi,
                'performanceIndicatorPollBatchSearchSlicePut',
                NetworkActionPrefix.LOAD_POLL_BATCH_SLICE_PREFIX,
                { pollSettingID },
                { SettingsID: pollSettingID },
                { startID, maxCount, order }
            );
        }
    };

export default polls;
